<template>
  <div class="mb-6">
    <vue-justified-layout :items="photos">
      <template slot="inner" slot-scope="slotProps">
        <nuxt-link
          v-if="slotProps && slotProps.item"
          :to="`/photo/${slotProps.item.id}/${
            slotProps.item.slug
          }?from=${from}${getQueries()}`"
          class="no-dec"
        >
          <v-hover>
            <v-img
              :key="slotProps.item.id"
              slot-scope="{ hover }"
              :src="$asa.getImageUrl(slotProps.item, 'thumb')"
              :lazy-src="$asa.getImageUrl(slotProps.item, 'thumb', true)"
              :alt="`${slotProps.item.title} by ${slotProps.item.photographerName} - 100ASA`"
            >
              <template #placeholder>
                <v-row
                  class="fill-height ma-0 color"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-row>
              </template>
              <div
                v-if="
                  me &&
                  me.id !== slotProps.item.photographerId &&
                  (me.isAdmin || me.role === types.user.role.curator) &&
                  (slotProps.item.statusName === types.photo.status.prime ||
                    slotProps.item.statusName ===
                      types.photo.status.inspiration) &&
                  isEliteVotedActive &&
                  slotProps.item.numberOfPromoteVotesElite > 0
                "
                class="
                  text-caption
                  py-1
                  px-2
                  bluezone
                  secondary--text
                  votes
                  font-italic font-weight-bold
                "
              >
                <span>
                  {{ slotProps.item.numberOfPromoteVotesElite }}
                  /
                  {{ slotProps.item.numberOfVoteToBePromotedElite }}
                </span>
              </div>
              <div
                v-if="
                  me &&
                  me.id !== slotProps.item.photographerId &&
                  (me.isAdmin || me.role === types.user.role.curator) &&
                  isInspirationVotedActive &&
                  ((slotProps.item.statusName === types.photo.status.prime &&
                  slotProps.item.numberOfPromoteVotesInspiration > 0) || slotProps.item.isNominated)
                "
                class="
                  text-caption
                  py-1
                  px-2
                  bluezone
                  secondary--text
                  votes
                  font-italic font-weight-bold
                "
              >
                <span>
                  {{ slotProps.item.numberOfPromoteVotesInspiration }}
                  /
                  {{ slotProps.item.numberOfVoteToBePromotedInspiration }}
                </span>
                <span v-if="slotProps.item.isNominated" class="ml-2">
                  <v-icon small color="white">
                    fas fa-users
                  </v-icon>
                </span>
              </div>
              <div
                v-if="
                  ((me && me.isNudeFilterActive) || !me) &&
                  (slotProps.item.isNude || slotProps.item.categoryId === 22)
                "
                class="obscure-photo"
              >
                <p class="text-body-2 ma-0">NSFW Content</p>
              </div>
              <v-fade-transition mode="in-out">
                <div v-if="hover">
                  <div
                    class="
                      d-flex
                      justify-space-between
                      transition-fast-in-fast-out
                      photo-overlay-top
                      pa-2
                    "
                    style="height: 50px"
                  >
                    <div></div>
                    <div class="d-flex justify-end">
                      <template v-if="me && (me.isEditor || me.isAdmin)">
                        <v-tooltip top>
                          <template #activator="{ on }">
                            <v-btn
                              dark
                              color="bluezone"
                              icon
                              v-on="on"
                              @click="
                                downloadEditorPhoto(
                                  $event,
                                  slotProps.item,
                                  false
                                )
                              "
                            >
                              <v-icon small> fal fa-cloud-download-alt </v-icon>
                            </v-btn>
                          </template>
                          <span> Download photo </span>
                        </v-tooltip>
                      </template>
                      <div>
                        <span
                          v-if="
                            from === 'galleries' &&
                            me &&
                            me.id === galleryOwnerId
                          "
                        >
                          <v-tooltip top>
                            <template #activator="{ on }">
                              <v-btn
                                dark
                                color="secondary"
                                icon
                                v-on="on"
                                @click="
                                  setGalleryThumbnail($event, slotProps.item)
                                "
                              >
                                <v-icon small> fal fa-image-polaroid </v-icon>
                              </v-btn>
                            </template>
                            <span> Set as gallery thumbnail </span>
                          </v-tooltip>
                          <v-btn
                            dark
                            color="secondary"
                            icon
                            @click="
                              removePhotoFromGallery($event, slotProps.item)
                            "
                          >
                            <v-icon small> fal fa-layer-minus </v-icon>
                          </v-btn>
                        </span>
                        <template v-else>
                          <!-- Curator photo dialog -->
                          <v-tooltip
                            v-if="
                              (slotProps.item.statusName ===
                                types.photo.status.prime ||
                                slotProps.item.statusName ===
                                  types.photo.status.inspiration || slotProps.item.isNominated) &&
                              me &&
                              me.id !== slotProps.item.photographerId &&
                              (me.role === types.user.role.curator ||
                                me.isAdmin)
                            "
                            top
                          >
                            <template #activator="{ on }">
                              <v-badge
                                :value="slotProps.item.hasCuratorNotes"
                                offset-x="10"
                                offset-y="10"
                                bordered
                                color="error"
                                dot
                                overlap
                              >
                                <v-btn
                                  dark
                                  color="bluezone"
                                  outlined
                                  icon
                                  v-on="on"
                                  @click="
                                    setCuratorsPhotoDialog(
                                      $event,
                                      slotProps.item
                                    )
                                  "
                                >
                                  <div>
                                    <v-icon dark small>
                                      fal fa-info-circle
                                    </v-icon>
                                  </div>
                                </v-btn>
                              </v-badge>
                            </template>
                            <span>
                              View info and actions about this photo
                            </span>
                          </v-tooltip>
                          <!-- Add photo to favourites -->
                          <v-tooltip top>
                            <template #activator="{ on }">
                              <v-btn
                                dark
                                color="secondary"
                                icon
                                v-on="on"
                                @click="
                                  openAddToGalleryDialog($event, slotProps.item)
                                "
                              >
                                <v-icon small> fal fa-layer-plus </v-icon>
                              </v-btn>
                            </template>
                            <span> Add photo to a gallery </span>
                          </v-tooltip>
                          <!-- Nominate for inspiration -->
                          <template
                            v-if="
                              !isEliteVotedActive &&
                              !isInspirationVotedActive &&
                              !me || ( me && 
                                me.id !== slotProps.item.photographerId &&
                                me.role !== types.user.role.curator
                              ) &&
                              slotProps.item.statusName !==
                                types.photo.status.elite &&
                              slotProps.item.statusName !==
                                types.photo.status.inspiration
                            "
                          >
                            <v-tooltip top>
                              <template #activator="{ on }">
                                <v-btn
                                  :disabled="
                                    nominatePhotoBusy &&
                                    nominatePhotoId === slotProps.item.id
                                  "
                                  :loading="
                                    nominatePhotoBusy &&
                                    nominatePhotoId === slotProps.item.id
                                  "
                                  dark
                                  color="secondary"
                                  icon
                                  v-on="on"
                                  @click="
                                    nominatePhoto($event, slotProps.item)
                                  "
                                >
                                  <v-icon small> fal fa-lightbulb-on </v-icon>
                                </v-btn>
                              </template>
                              <span> Nominate this photo </span>
                            </v-tooltip>
                          </template>
                          <!-- Like photo -->
                          <v-tooltip top>
                            <template #activator="{ on }">
                              <v-btn
                                :disabled="
                                  likePhotoBusy &&
                                  likePhotoId === slotProps.item.id
                                "
                                :loading="
                                  likePhotoBusy &&
                                  likePhotoId === slotProps.item.id
                                "
                                dark
                                color="secondary"
                                icon
                                v-on="on"
                                @click="
                                  likePhoto(
                                    $event,
                                    slotProps.item.hasLikedAlready ? -1 : 1,
                                    slotProps.item.id,
                                    slotProps.item.photographerId,
                                    from
                                  )
                                "
                              >
                                <v-icon small>
                                  {{
                                    slotProps.item.hasLikedAlready
                                      ? 'fas'
                                      : 'fal'
                                  }}
                                  fa-heart
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>
                              {{
                                slotProps.item.hasLikedAlready
                                  ? 'Dislike'
                                  : 'Like'
                              }}
                              this photo
                            </span>
                          </v-tooltip>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div
                    class="
                      d-flex
                      transition-fast-in-fast-out
                      photo-overlay
                      pa-2
                    "
                    style="height: 50px"
                  >
                    <nuxt-link
                      :to="`/photographer/${
                        slotProps.item.photographerUserName ||
                        slotProps.item.photographerId
                      }`"
                      class="
                        secondary--text
                        text-body-2
                        d-inline-block
                        photographer-link
                        text-truncate
                      "
                    >
                      <v-avatar size="30">
                        <img
                          :src="slotProps.item.photographerAvatarUrl"
                          :alt="`${slotProps.item.photographerName}`"
                        />
                      </v-avatar>
                      <span class="ml-2">
                        {{ slotProps.item.photographerName }}
                      </span>
                    </nuxt-link>
                  </div>
                </div>
              </v-fade-transition>
            </v-img>
          </v-hover>
        </nuxt-link>
      </template>
    </vue-justified-layout>
    <div v-intersect="onIntersect" />
    <div v-if="loading" class="text-center">
      <v-icon class="fa-spin my-3"> fal fa-spinner </v-icon>
    </div>
    <div v-if="!loading && photos.length === 0 && mounted" class="text-center">
      <v-alert outlined color="primary">
        <v-icon class="mr-3">far fa-sad-cry</v-icon>
        No photos found or no results for this search
      </v-alert>
    </div>
    <Curators-photo-info-dialog />
    <Galleries-dialog />
  </div>
</template>

<script>



import { mapState } from 'vuex'
import VueJustifiedLayout from 'vue-justified-layout'
import { likePhotoMixin } from '@/mixins/likePhotoMixin'
import { nominatePhotoMixin } from '@/mixins/nominatePhotoMixin'
import { editorsMixin } from '@/mixins/editorsMixin'
import types from '@/utils/types'
import { displayConfirm } from '@/utils/swal'
import { EventBus } from '@/plugins/event-bus'

export default {
  name: 'Gallery',
  components: {
    VueJustifiedLayout,
    CuratorsPhotoInfoDialog: () =>
      import('@/components/galleries/CuratorsPhotoInfoDialog.vue'),
    GalleriesDialog: () => import('@/components/galleries/GalleriesDialog.vue')
  },
  mixins: [likePhotoMixin, nominatePhotoMixin, editorsMixin],
  props: {
    photos: {
      type: Array,
      default: () => [],
      required: true
    },
    me: {
      type: [Object, Boolean],
      default: () => {}
    },
    loadMore: {
      type: Function,
      required: true
    },
    autoLoadDisabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    getQueries: {
      type: Function,
      required: true
    },
    isEliteVotedActive: {
      type: Boolean,
      default: false
    },
    isInspirationVotedActive: {
      type: Boolean,
      default: false
    },
    galleryOwnerId: {
      type: [Number, undefined],
      default: undefined
    },
    from: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      types,
      mounted: false,
      promotePhotoId: undefined
    }
  },
  computed: {
    ...mapState({
      errorMessage: state => state.photos.errorMessage
    })
  },
  mounted() {
    this.mounted = true
  },
  methods: {
    onIntersect(entries) {
      if (entries[0].intersectionRatio > 0 && !this.autoLoadDisabled) {
        this.loadMore()
      }
    },
    openAddToGalleryDialog(event, photo) {
      event.preventDefault()
      this.$store.dispatch('galleries/setSelectedPhotoToAdd', photo)
      this.$store.dispatch('galleries/setAddPhotoToGalleryDialogVisible', true)
    },
    async setGalleryThumbnail(event, photo) {
      event.preventDefault()
      const galleryId = this.$route.params.id
      try {
        await this.$store.dispatch('galleries/setGalleryThumbnail', {
          galleryId,
          photoId: photo.id
        })
        EventBus.$emit('snackbar', {
          text: 'Thumbnail successfully updated',
          color: 'success'
        })
      } catch (error) {
        this.$asa.appInsights('Comp: components/galleries/Gallery.vue - method: setGalleryThumbnail', error)
      }
    },
    removePhotoFromGallery(event, photo) {
      event.preventDefault()
      const galleryId = this.$route.params.id
      if (galleryId) {
        displayConfirm(
          'Are you sure you wish to remove this photo from your gallery?',
          async result => {
            if (result.isConfirmed) {
              try {
                const data = {
                  photoId: photo.id,
                  galleryId
                }
                await this.$store.dispatch('galleries/removePhoto', data)
                EventBus.$emit('snackbar', {
                  text: 'The photo has been successfully removed',
                  color: 'success'
                })
              } catch (error) {
                this.$asa.appInsights('Comp: components/galleries/Gallery.vue - method: removePhotoFromGallery', error)
              }
            }
          }
        )
      }
    },
    setCuratorsPhotoDialog(event, photo) {
      event.preventDefault()
      this.$store.dispatch('photos/setCuratorsPhotoDialogPhoto', photo)
      this.$store.dispatch('photos/setCuratorsPhotoDialog', true)
    }
  }
}
</script>

<style scoped>



.photographer-link {
  line-height: 30px;
  text-decoration: none;
  height: 30px;
}
.no-dec {
  text-decoration: none;
}
.votes {
  border-radius: 8px;
  opacity: 0.7;
  padding: 2px 5px;
  position: absolute;
  top: 4px;
  left: 4px;
}
.photo-overlay {
  align-items: center;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
  position: absolute;
  bottom: 0;
  width: 100%;
}
.photo-overlay-top {
  align-items: center;
  background: linear-gradient(to top, transparent 0%, rgba(0, 0, 0, 0.6) 100%);
  position: absolute;
  top: 0;
  width: 100%;
}
.obscure-photo {
  align-items: center;
  background-color: #212121;
  color: white;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
